import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchStorages, ProfileStorageLocation} from 'api/documents/create';
import {fetchReturnGoodsDictionary, submitDocumentReturnGoods} from 'api/documents/returnGoods';
import {rootDomain} from 'core/rootDomain';
import {GeneralInfoData, ReturnGoodsDictionaryResponse} from 'types';

import {createDocumentReturnGoodsFx} from '../create';

const domain = rootDomain.createDomain('DocumentsListDomain');

export const DocumentsReturnsGate = createGate('DocumentsReturnsGate');
export const CreateDocumentsReturnsGate = createGate('CreateDocumentsReturnsGate');

export const step$ = domain.createStore<number>(0);
export const stepChanged = domain.createEvent<number>();

export const fetchStoragesFx = domain.createEffect({
    name: 'fetchStoragesFx',
    handler: fetchStorages,
});

export const fetchReturnGoodsDictionaryFx = domain.createEffect({
    name: 'fetchReturnGoodsDictionaryFx',
    handler: fetchReturnGoodsDictionary,
});

export const submitDocumentReturnGoodsFx = domain.createEffect({
    name: 'submitDocumentReturnGoodsFx',
    handler: submitDocumentReturnGoods,
});

export const firstStep$ = domain.createStore<GeneralInfoData>({
    markingCode: '',
    returnDate: new Date(),
    referenceDocNumber: '',
    productCondition: null,
    comment: '',
    storageLocation: null,
    disposalReason: null,
});
export const firstStepChanged = domain.createEvent<GeneralInfoData>();

export const storages$ = domain.createStore<ProfileStorageLocation[]>([]);
export const returnGoodsDictionary$ = domain.createStore<ReturnGoodsDictionaryResponse>({
    productConditions: [],
    disposalReasons: [],
    returnGoodsSources: [],
    returnTypes: [],
});

export const isFetchPending$ = combine(
    createDocumentReturnGoodsFx.pending,
    fetchStoragesFx.pending,
    fetchReturnGoodsDictionaryFx.pending,
    (createDocumentReturnGoodsPending, fetchStoragesPending, fetchDictionaryPending) =>
        createDocumentReturnGoodsPending || fetchStoragesPending || fetchDictionaryPending,
);
